// @ts-ignore
import CommentOverlay from 'media/images/comment-overlay.png?base64';
import { useEffect, useState } from 'react';
import { urlBoxFetchImage } from 'utils/constants';
import Skeleton from '../Skeleton';
import { GetItemDetailsProps } from '../UpdateUsernamePrompt';


export type RightSideDesignProps = {
    projectScreenshot: string;
    collabMode: boolean;
    imageGraphicItem: any;
    itemType: string;
    projectUrl: string;
    itemDetails: GetItemDetailsProps;
};
export default function AuthRightSideDesign({ projectScreenshot, collabMode, imageGraphicItem, itemType, projectUrl, itemDetails }: RightSideDesignProps) {

    const [isLoading, setIsLoading] = useState(true);
    const [loadedSrc, setLoadedSrc] = useState<string | null>(null);

    useEffect(() => {
        // Initialize loading state
        setIsLoading(true);

        // Create a new image object
        const img = new Image();

        // Set up the onload event handler
        img.onload = () => {
            setIsLoading(false); // Image has loaded
            setLoadedSrc(
                itemType === 'graphic'
                    ? imageGraphicItem?.image
                    : projectScreenshot
                        ? projectScreenshot
                        : urlBoxFetchImage + projectUrl
            ); // Set loadedSrc to the image URL
        };

        // Set up the onerror event handler
        img.onerror = () => {

            if (itemDetails?.image === null && itemDetails?.url_host) {
                let imgUrl: string = ''
                // Check if the URL starts with "https://"
                if (itemDetails?.url_host.startsWith('https://')) {
                    imgUrl = urlBoxFetchImage + itemDetails?.url_host;
                    setLoadedSrc(imgUrl);
                } else {
                    imgUrl = urlBoxFetchImage + 'https://' + itemDetails?.url_host;
                    setLoadedSrc(imgUrl);
                }
                setIsLoading(false);
                return;
            }
            setIsLoading(true); // Stop loading on error
            console.error('Failed to load image');
        };

        // Set the source of the image object to start loading
        img.src =
            itemType === 'graphic'
                ? imageGraphicItem?.image
                : projectScreenshot
                    ? projectScreenshot
                    : urlBoxFetchImage + projectUrl;

        // Optional: Return a cleanup function in case the component unmounts before the image loads
        return () => {
            img.onload = null;
            img.onerror = null;
        };
    }, [imageGraphicItem?.image, projectScreenshot, projectUrl, itemDetails]); // Effect dependencies

    return (
        <>
            <div className="flex w-7/12 items-center justify-center">
                <div className="px-10">
                    <div className="m-b-[30px]">
                        <h2 className="text-[22px] text-white font-sans mb-2 font-semibold text-center">
                            {collabMode
                                ? 'Ready To Give Your Feedback?'
                                : 'Get Instant Feedback From Your Customers'}
                        </h2>
                        <p className='text-center text-sm text-white mb-4'>
                            {collabMode
                                ? 'Simply click any part of the page to leave a comment and instantly notify others who are doing the work, so they can get it done fast!'
                                : 'Atarim makes it easy to see what your customers and stakeholders need, with comments being attached to specific elements on their website along with an automatic screenshot showing you what they selected'}
                        </p>
                    </div>
                    <div className="flex">
                        <div className="w-[100%] relative">
                            <img
                                src={CommentOverlay}
                                alt="project-sample-task"
                                className="absolute h-full w-full left-0 top-0 -ml-[30px] z-[1]"
                            />
                            {isLoading && (
                                <div>
                                    <div className="at-cs-sign-up-right-section-screenshot">
                                        <Skeleton className="w-full rounded-xl bg-background w-full aspect-video" />
                                        <div
                                            className="absolute text-center text-[12px] font-medium text-[#6d5df3] font-roboto"
                                            style={{ top: 'calc(50% - 9px)', left: 'calc(50% - 43px)' }}
                                        >
                                            Loading Preview
                                        </div>
                                    </div>
                                </div>
                            )}
                            {!isLoading && loadedSrc && (
                                <img
                                    src={loadedSrc}
                                    alt="project-screenshot"
                                    className="aspect-video w-full rounded-lg bg-background object-cover shadow-lg"
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export const TaskCardSkeleton = () => {
    return (
        <div className="flex h-28 w-full gap-1 rounded-lg border bg-background p-2">
            <div className="flex h-full w-10 flex-col items-center justify-between">
                <Skeleton className="size-8 rounded-[15%_50%_50%_50%]" />
                <Skeleton className="h-5 w-8 rounded" />
                <Skeleton className="h-5 w-5 rounded" />
            </div>
            <div className="flex h-full flex-1 flex-col gap-1 overflow-hidden text-left">
                <div className="flex items-center justify-between">
                    <Skeleton className="h-4 w-24" />
                    <Skeleton className="h-4 w-12" />
                </div>
                <Skeleton className="h-8 w-full" />
                <div className="mt-auto flex items-center justify-between">
                    <div className="flex items-center gap-1">
                        <Skeleton className="h-4 w-4 rounded-full" />
                        <Skeleton className="h-4 w-20" />
                    </div>
                    <div className="flex">
                        <Skeleton className="h-5 w-5 rounded-full" />
                        <Skeleton className="-ml-2 h-5 w-5 rounded-full" />
                        <Skeleton className="-ml-2 h-5 w-5 rounded-full" />
                    </div>
                </div>
            </div>
        </div>
    );
};